import { render, staticRenderFns } from "./Cinema-list.vue?vue&type=template&id=4bcf912c&scoped=true&"
import script from "./Cinema-list.vue?vue&type=script&lang=js&"
export * from "./Cinema-list.vue?vue&type=script&lang=js&"
import style0 from "./Cinema-list.vue?vue&type=style&index=0&id=4bcf912c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf912c",
  null
  
)

export default component.exports